import moment from 'moment';
import { FILE, FORMAT } from '../constant';
import { isInApp } from './device';
import { showToastError } from './toast';

export const getThumbor = (dimension = '48x48', quality = 80) => {
    if (process.env.REACT_APP_THUMBOR_URL) return `${process.env.REACT_APP_THUMBOR_URL}/${dimension}/filters:quality(${quality})/`
    else return ''
}

// Force download a file (handles cross-origin S3 URLs and base64)
const _BROWSER_VIEWABLE = /\.(pdf|docx?|xlsx?|pptx?|txt|csv|svg|xml|jpe?g|png|gif|webp|bmp)([?#]|$)/i;
export const downloadFile = (fileUrl, fileName) => {
    if (!fileUrl) return;
    if (isInApp()) {
        window.open(fileUrl)
        return;
    }
    if (fileUrl.startsWith('data:') || fileUrl.startsWith('blob:')) {
        const a = document.createElement('a');
        a.href = fileUrl;
        a.download = fileName || 'download';
        document.body.appendChild(a);
        a.click();
        a.remove();
        return;
    }
    const iframeFallback = () => {
        try {
            const iframe = document.createElement('iframe');
            iframe.style.visibility = 'collapse';
            document.body.appendChild(iframe);
            iframe.contentDocument.write(
                `<form action="${fileUrl.replace(/"/g, '&quot;')}" method="GET"></form>`
            );
            iframe.contentDocument.forms[0].submit();
            setTimeout(() => iframe.remove(), 2000);
        } catch (e) {
            window.open(fileUrl, '_blank');
        }
    };
    if (_BROWSER_VIEWABLE.test(fileUrl)) {
        fetch(fileUrl)
            .then(res => { if (!res.ok) throw new Error('Download failed'); return res.blob(); })
            .then(blob => {
                const link = document.createElement('a');
                const blobUrl = window.URL.createObjectURL(blob);
                link.href = blobUrl;
                let ext = fileUrl.split('.').pop().split(/[#?]/)[0];
                if (!ext || ext.length > 5) ext = '';
                let name = fileName || 'download';
                if (ext && !name.endsWith(`.${ext}`)) name = `${name}.${ext}`;
                link.download = name;
                document.body.appendChild(link);
                link.click();
                link.remove();
                setTimeout(() => window.URL.revokeObjectURL(blobUrl), 100);
            })
            .catch(() => { iframeFallback(); });
        return;
    }
    iframeFallback();
};

export const dataURLtoFile = (dataUrl, filename, mime = "image/jpg") => {
    let arr = dataUrl.split(','),
        bstr = atob(arr[1]),
        n = bstr.length,
        u8arr = new Uint8Array(n);
    while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
    }
    return new File([u8arr], filename, { type: mime });
}

export const isThisAFile = (maybeFile) => {
    return new Promise(function (resolve, reject) {
        if (maybeFile.type !== '') {
            return resolve(maybeFile);
        }
        const reader = new FileReader();
        reader.onloadend = () => {
            if (reader.error && reader.error.name === 'NotFoundError') {
                return reject(reader.error.name);
            }
            resolve(maybeFile);
        };
        reader.readAsBinaryString(maybeFile);
    });
};

export const checkAttachment = (url) => {
    /** check attachment type */
    if (url) {
        const name = url?.split('.');
        const ext = name[name?.length - 1];
        return ext;
    }
}

export const bytesToSize = (bytes) => {
    const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
    if (bytes === 0) return '0 Byte';
    const i = parseInt(Math.floor(Math.log(bytes) / Math.log(1024)));
    return Math.round(bytes / Math.pow(1024, i), 2) + ' ' + sizes[i];
};

export const getExtension = (url) => {
    return url?.split(/[#?]/)[0].split('.')?.pop()?.trim() || '-';
}

export const getFileType = (url = "") =>  {
    if(FILE?.PDF?.test(`.${checkAttachment(url)}`)){
        return FILE.TYPE.PDF
    }else if(FILE?.IMAGES?.test(`.${checkAttachment(url)}`)){
        return FILE.TYPE.IMAGES
    }else if(FILE?.DOCS_ONLY?.test(`.${checkAttachment(url)}`)){
        return FILE.TYPE.DOCS_ONLY
    }else {
        return null;
    }
}

export const prepareFiles = async (data, limit, callback) => {
    if (data.length <= 10) {
        let sizeError = false;
        const fileArray = Object.assign([], data);
        for (let i = 0; i < fileArray.length; i++) {
            if (!sizeError) sizeError = fileArray[i].size / 1024 / 1024 > limit;
        }
        if (!sizeError) {
            let myFiles = [];
            const number = data.length;
            for (let i = 0; i < number; i++) {
                const name = fileArray[i].name.split('.');
                const ext = name[name.length - 1];
                if (!FILE.EXCLUDES.includes(ext)) {
                    await isThisAFile(fileArray[i]).then(validFile => {
                        myFiles.push(validFile);
                    }).catch(error => {
                    });
                }
            }
            // Exclude Duplicate Files
            myFiles = myFiles.filter((file, index, data) =>
                index === data.findIndex((d) => (d.name === file.name && d.size === file.size))
            );
            callback(myFiles);
        } else showToastError(`Files must smaller than ${limit}MB!`);
    } else showToastError('You can only upload 10 files at a time.');
};

// ===== migrated from pms/src/common/functions/common.jsx =====
export const getThumb = (image) => {
    let part = (image && image !== '') ? image.split('.') : []
    return (part.length) ? part[0] + '_thumb_48x48.' + part[1] : image;
}

export const downloadFiles = file => {
    const anchor = document.createElement('a');
    anchor.href = file;
    anchor.target = '_blank';
    document.body.appendChild(anchor);
    anchor.click();
    document.body.removeChild(anchor);
};

export const downloadBase64ToPDF = (base64String, filename = `pdf-file-${moment().format(FORMAT.FULL_DATE_TIME)}`, isURL) => {
    try {
        // Convert Base64 string to a data URI
        const dataURI = `data:application/pdf;base64,${base64String}`;

        // Create a temporary anchor tag
        const anchor = document.createElement('a');
        anchor.href = isURL ? base64String : dataURI;
        anchor.download = filename || 'document.pdf';
        // Trigger the download
        anchor.click();
    } catch (error) {
        console.log("Download Base64 to PDF catch error =======> ", error)
    }
};